import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import type {
  GetAssessmentTeachingAndLearningSequenceQuery,
  GetAssessmentTeachingAndLearningSequenceQueryVariables,
} from './teaching-notes.graphql.generated';
import { GET_ASSESSMENT_TEACHING_LEARNING_SEQUENCE } from './teaching-notes.graphql';

type GetSequencesProps = {
  contentId: number;
  classId?: number;
  fetchPolicy?: WatchQueryFetchPolicy;
  version?: string | null;
  skip?: boolean;
  authenticate?: boolean;
};

export const useGetAssessmentSequences = ({
  contentId,
  classId,
  fetchPolicy = 'cache-first',
  version,
  skip,
  authenticate = true,
}: GetSequencesProps) => {
  const { showError } = useSnackbar();
  const { data, loading, error } = useLoggingQuery<
    GetAssessmentTeachingAndLearningSequenceQuery,
    GetAssessmentTeachingAndLearningSequenceQueryVariables
  >(
    GET_ASSESSMENT_TEACHING_LEARNING_SEQUENCE,
    {
      skip,
      variables: {
        input: {
          contentId,
          classId,
          isDraft: !version,
        },
      },
      fetchPolicy,
      onError: () => showError('There was an error retrieving teaching notes'),
    },
    authenticate
  );
  const sequences = data?.getAssessmentTeachingAndLearningSequence || null;

  return {
    sequences,
    loading,
    error,
  };
};
